import React, { memo } from "react";
import { Layout } from "antd";

import "./styles.scss";

const { Footer } = Layout;

const FooterComponent = () => {
	return <Footer className="footer">2021 © Driver Recruitment Software</Footer>;
};

export default memo(FooterComponent);